import React, { useState } from "react";
import { useNavigate } from "react-router";

import { useAppRouteParams } from "../../../../../AppRoutes";
import { postRemoveVersion } from "../../../../../api/version";
import { Version } from "../../../../../domain/Version";
import { DialogPhaseStatesType, useDialog } from "../../../helpers/hooks";
import { getDialogMessages } from "../../helper";

export const DialogVersionRemove: React.FC<
  {
    versions: Version[];
    selectedVersionIds: string[];
    setSelectedVersionIds: React.Dispatch<React.SetStateAction<string[]>>;
  } & DialogPhaseStatesType
> = ({
  versions,
  selectedVersionIds,
  setSelectedVersionIds,
  dialogPhase,
  setDialogPhase,
}) => {
  const selectedVersion = versions.find(
    ({ id }) => selectedVersionIds?.[0] === id
  );

  const { organizationId, versionId } = useAppRouteParams();
  const navigate = useNavigate();

  const { renderDialogs, setIsInProgress, showErrorAPIDialog } = useDialog({
    dialogPhase,
    setDialogPhase,
  });

  const runRemove = async () => {
    if (selectedVersionIds.includes(versionId)) {
      navigate(`/organizations/${organizationId}`);
    }
    setDialogPhase("in_progress");
    try {
      await postRemoveVersion({
        organizationId,
        versionId: selectedVersionIds[0],
      });
      setSelectedVersionIds([]);
      setDialogPhase("success");
    } catch (error) {
      showErrorAPIDialog(error);
    }
  };
  const messages = getDialogMessages({
    isSome: false,
    actionType: "remove",
    targetType: "version",
  });
  return (
    <>
      {renderDialogs({
        confirm: {
          onClick: runRemove,
          onClickCancel: () => {
            setSelectedVersionIds([]);
          },
          isThemeRed: true,
          ...messages.confirm,
        },
        inProgress: {
          ...messages.inProgress,
        },
        success: {
          ...messages.success,
        },
        errorAPI: { ...messages.error },
      })}
    </>
  );
};
